import { n as i } from "./property-9daa16cd.mjs";
import { r as h } from "./state-7560d4dc.mjs";
import { i as x, E as b, x as t, a as p, r as g } from "./createReactComponent-58f9bea8.mjs";
import { e as u } from "./class-map-2994e95e.mjs";
import { r as v } from "./icon-c572aa57.mjs";
const m = x`
  :host {
    display: inline-block;
  }

  /* Radio Wrapper */
  :host .radio {
    box-sizing: border-box;
    font-family: var(--exo-font-family);
    font-size: var(--exo-font-size-small);
    font-weight: var(--exo-font-weight-regular);
    line-height: var(--exo-line-height-denser);
    color: var(--exo-color-font);
    display: inline-flex;
    gap: var(--exo-spacing-3x-small);
    cursor: pointer;
  }

  /* Radio Input Element */
  :host .radio__input {
    flex: 0 0 auto;
    align-self: flex-start;
    width: var(--exo-spacing-standard);
    height: var(--exo-spacing-standard);
    margin: var(--exo-spacing-3x-small);
    box-sizing: border-box;
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-deselected);
    border-radius: var(--exo-radius-circle);
    background-clip: content-box;
    background-color: var(--exo-color-background);
  }

  /* Radio Label Element */
  :host .radio__label {
    display: flex;
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-2x-small)
      var(--exo-spacing-2x-small) var(--exo-spacing-none);
    align-items: flex-start;
    gap: var(--exo-spacing-2x-small);
    align-self: stretch;
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  :host .radio__input-box {
    display: flex;
    border-radius: var(--exo-spacing-2x-small);
    padding: var(--exo-spacing-2x-small);
    width: calc(0.25 * var(--exo-size-1));
    height: calc(0.25 * var(--exo-size-1));
  }

  /* Selected */
  :host .radio--checked .radio__input {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected);
    background-color: var(--exo-color-background-selected);
    padding: var(--exo-spacing-3x-small);
  }

  /* Focus Unselected */
  :host .radio:focus-visible {
    border-radius: var(--exo-spacing-2x-small);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  /* Focus Selected */
  :host .radio--checked:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
    border-radius: var(--exo-spacing-2x-small);
  }

  /* Hover Unselected */
  :host .radio:focus-visible .radio__input-box,
  :host .radio .radio__input-box:hover,
  :host .radio:hover .radio__input-box {
    background: var(--exo-color-background-action-hover-weak);
  }

  /* Hover Selected */
  :host .radio--checked:focus-visible .radio__input-box,
  :host .radio.radio--checked .radio__input-box:hover,
  :host .radio--checked:hover .radio__input-box {
    background: var(--exo-color-background-action-secondary-hover);
  }

  /* disabled Selected */
  :host .radio--disabled .radio,
  :host .radio--disabled .radio__label {
    color: var(--exo-color-font-secondary);
    pointer-events: none;
    cursor: not-allowed;
  }

  :host .radio--disabled .radio--checked .radio__input {
    background-color: var(--exo-color-background-disabled);
  }

  :host .radio--disabled .radio--checked.radio--focused .radio__input {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-disabled);
  }

  :host .radio--disabled .radio__input {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-disabled);
    background-color: var(--exo-color-background);
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
  }

  :host .help-text {
    display: flex;
    gap: var(--exo-spacing-2x-small);
    padding-left: calc(var(--exo-spacing-medium) + var(--exo-spacing-small));
    font: var(--exo-text-label-micro);
  }

  /* Radio Footer Type */

  :host .radio__footer-info {
    color: var(--exo-color-background-info-strong);
  }

  :host .radio__footer-success {
    color: var(--exo-color-background-success-strong);
  }

  :host .radio__footer-error {
    color: var(--exo-color-background-danger-strong);
  }

  :host .radio__footer-warning {
    color: var(--exo-color-background-warning-strong);
  }

  /* Radio size */

  :host .radio--size-large {
    max-width: var(--exo-size-5);
  }

  :host .radio--size-medium {
    max-width: var(--exo-size-4);
  }

  :host .radio--size-small {
    max-width: var(--exo-size-2);
  }
`;
var f = Object.defineProperty, k = Object.getOwnPropertyDescriptor, r = (e, o, l, n) => {
  for (var d, s = n > 1 ? void 0 : n ? k(o, l) : o, c = e.length - 1; c >= 0; c--)
    (d = e[c]) && (s = (n ? d(o, l, s) : d(s)) || s);
  return n && s && f(o, l, s), s;
}, _ = ((e) => (e.MEDIUM = "medium", e.SMALL = "small", e.LARGE = "large", e))(_ || {}), y = ((e) => (e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e.WARNING = "warning", e))(y || {});
class a extends b {
  constructor() {
    super(...arguments), this.checked = !1, this.hasFocus = !1, this.helpText = "", this.size = "medium", this.footerType = "info", this.showStatusIcon = !1, this.disabled = !1, this.value = "", this.statusIconLabel = "";
  }
  connectedCallback() {
    super.connectedCallback(), this.setInitialAttributes(), this.addEventListeners();
  }
  handleBlur() {
    this.hasFocus = !1;
  }
  handleClick() {
    this.disabled || (this.checked = !0);
  }
  handleFocus() {
    this.hasFocus = !0;
  }
  handleKeyup(o) {
    o.code === "Space" && this.handleClick();
  }
  setInitialAttributes() {
    this.setAttribute("role", "radio");
  }
  addEventListeners() {
    this.addEventListener("blur", this.handleBlur), this.addEventListener("click", this.handleClick), this.addEventListener("focus", this.handleFocus), this.addEventListener("keyup", this.handleKeyup);
  }
  updated(o) {
    super.updated(o), o.has("checked") && (this.checked ? this.setAttribute("aria-checked", "true") : this.setAttribute("aria-checked", "false"));
  }
  setStatusIcon() {
    if (this.showStatusIcon)
      switch (this.footerType) {
        case "success":
          return t`<ex-icon
            size="XS"
            icon="Success"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        case "error":
          return t`<ex-icon
            size="XS"
            icon="Error"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        case "warning":
          return t`<ex-icon
            size="XS"
            icon="Warning"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        default:
          return t`<ex-icon
            size="XS"
            icon="Information"
            label=${this.statusIconLabel}
          ></ex-icon>`;
      }
    return p;
  }
  getInfoFooter() {
    return this.helpText ? t`
        <span class="help-text" @click=${(o) => o.stopPropagation()}>
          ${this.setStatusIcon()}${this.helpText}
        </span>
      ` : p;
  }
  render() {
    return t`
      <div
        part="radio-parent"
        class=${u({ "radio--size-small": this.size === "small", "radio--size-medium": this.size === "medium", "radio--size-large": this.size === "large", "radio--disabled": this.disabled })}
      >
        <span
          part="radio"
          class=${u({ radio: !0, "radio--checked": this.checked })}
          tabindex="0"
        >
          <span class="radio__input-box" part="inputBox"
            ><span class="radio__input" part="checkbox"></span
          ></span>
          <span part="radio-label" class="radio__label">
            <slot></slot>
          </span>
        </span>
        <span class="radio__footer-${this.footerType}">
          ${this.getInfoFooter()}</span
        >
      </div>
    `;
  }
}
a.styles = m, r([h()], a.prototype, "checked", 2), r([h()], a.prototype, "hasFocus", 2), r([i({ attribute: "help-text" })], a.prototype, "helpText", 2), r([i()], a.prototype, "size", 2), r([i()], a.prototype, "footerType", 2), r([i({ type: Boolean, reflect: !0 })], a.prototype, "showStatusIcon", 2), r([i({ type: Boolean, reflect: !0 })], a.prototype, "disabled", 2), r([i({ type: String, reflect: !0 })], a.prototype, "value", 2), r([i({ type: String })], a.prototype, "statusIconLabel", 2);
const E = (e = "") => {
  g("ex-radio", a, e), v(e);
};
export {
  _ as R,
  y as a,
  a as b,
  E as r
};
